import { render } from "./ResultadoFiles.vue?vue&type=template&id=60ce7ef5&scoped=true"
import script from "./ResultadoFiles.vue?vue&type=script&lang=js"
export * from "./ResultadoFiles.vue?vue&type=script&lang=js"

import "./ResultadoFiles.vue?vue&type=style&index=0&id=60ce7ef5&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ce7ef5"]])

export default __exports__